module.exports = "/images/vendor/flag-icon-css/flags/1x1/uz.svg?ca892343cb962d42bc4cc36d776d63e8";